__turbopack_context__.v({
  "buttons-container": "_2j76VG_buttons-container",
  "gift-card-container": "_2j76VG_gift-card-container",
  "giftcard-add-to-cart": "_2j76VG_giftcard-add-to-cart",
  "giftcard-buttons-container": "_2j76VG_giftcard-buttons-container",
  "giftcard-details-dropdown": "_2j76VG_giftcard-details-dropdown",
  "giftcard-dropdown-label": "_2j76VG_giftcard-dropdown-label",
  "giftcard-input": "_2j76VG_giftcard-input",
  "giftcard-textarea": "_2j76VG_giftcard-textarea",
  "giftcard-textarea-container": "_2j76VG_giftcard-textarea-container",
  "giftcard-textarea-counter": "_2j76VG_giftcard-textarea-counter",
  "open-amount-note": "_2j76VG_open-amount-note",
  "qty-selector": "_2j76VG_qty-selector",
  "title": "_2j76VG_title",
});
